export default __webpack_public_path__ + "static/media/32-icon-close.3fecbef9.svg";